var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_6823)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5571,
    cy: 20.4972,
    r: 20.4429,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 0C9.17808 0 0 9.17808 0 20.4999C0 31.8217 9.17808 41.0001 20.4999 41.0001C31.8217 41.0001 41.0001 31.8217 41.0001 20.4999C40.9874 9.18333 31.8168 0.0127624 20.4999 0ZM20.4999 38.9499C10.3102 38.9499 2.04988 30.6896 2.04988 20.4999C2.04988 10.3102 10.3102 2.04988 20.4999 2.04988C30.6896 2.04988 38.9499 10.3102 38.9499 20.4999C38.9382 30.6847 30.6847 38.9382 20.4999 38.9499Z",
    fill: "#C1C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0997 12.5534C17.6733 12.1806 17.0258 12.2242 16.653 12.6502C16.2807 13.0766 16.3242 13.7241 16.7503 14.0969L24.0684 20.4999L16.7499 26.9032C16.3235 27.276 16.2803 27.9235 16.6527 28.3495C17.0254 28.7759 17.6729 28.8195 18.0993 28.4467L26.2992 21.2716C26.5218 21.0772 26.6494 20.7956 26.6494 20.4999C26.6494 20.2041 26.5218 19.9229 26.2992 19.7281L18.0997 12.5534Z",
    fill: "#504F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_6823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.5a0d1059eb9e93bf49dff1fd5d45075d.svg";
export { ForwardRef as ReactComponent };